import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UserCardComponent} from './user-card.component';
import {RouterModule} from '@angular/router';
import {DateAgoModule} from '../../../../core/pipe/date-ago.module';
import {ImgOrLetterPictureModule} from '../../img-or-letter/img-or-letter-picture.module';

@NgModule({
  declarations: [
    UserCardComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        DateAgoModule,
        ImgOrLetterPictureModule,
    ],
  exports: [
    UserCardComponent
  ],
  providers: [],
})
export class UserCardModule {
}
